import script from "./ClientProjectDeail.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientProjectDeail.vue?vue&type=script&setup=true&lang=js"

import "./ClientProjectDeail.vue?vue&type=style&index=0&id=3bbfa798&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bbfa798"]])

export default __exports__